export default __webpack_public_path__ + "static/media/BlogWebsite.ba910276.jpg";